import { LiveAudioSkinElement } from '../../presets/live-audio/skin';
import { safeDefine } from '../../registration/safe-define';
import '../../internal/skins/default-live-audio/register';

safeDefine(LiveAudioSkinElement);
